var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.3332 13.7841C18.3332 16.1091 16.4666 17.9925 14.1416 18.0008H14.1332H5.8749C3.55823 18.0008 1.66656 16.1258 1.66656 13.8008V13.7925C1.66656 13.7925 1.67156 10.1041 1.67823 8.24915C1.67906 7.90081 2.07906 7.70581 2.35156 7.92248C4.33156 9.49331 7.8724 12.3575 7.91657 12.395C8.50823 12.8691 9.25823 13.1366 10.0249 13.1366C10.7916 13.1366 11.5416 12.8691 12.1332 12.3858C12.1774 12.3566 15.6391 9.57831 17.6491 7.98165C17.9224 7.76415 18.3241 7.95915 18.3249 8.30665C18.3332 10.1475 18.3332 13.7841 18.3332 13.7841Z",
    fill: "#DCE3DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8967 5.22833C17.175 3.86833 15.755 3 14.1917 3H5.87499C4.31166 3 2.89166 3.86833 2.16999 5.22833C2.00832 5.5325 2.08499 5.91167 2.35416 6.12667L8.54166 11.0758C8.97499 11.4258 9.49999 11.6 10.025 11.6C10.0283 11.6 10.0308 11.6 10.0333 11.6C10.0358 11.6 10.0392 11.6 10.0417 11.6C10.5667 11.6 11.0917 11.4258 11.525 11.0758L17.7125 6.12667C17.9817 5.91167 18.0583 5.5325 17.8967 5.22833Z",
    fill: "#02291C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.8a74c519.svg";
export { ForwardRef as ReactComponent };